import React from 'react';
import { connect } from 'react-redux';
import { removeHtmlTags } from '../../utilities/methods';

import Card from '../Accordion/Card';

import "./Room.css";

const SingleNote = ({ noteType, paragraph }) => {
    const getButtonStyle = {
        backgroundColor:
            noteType === "A" ? "#C8E6C9" :
                noteType === "PA" ? "#FFF9C4" :
                    "#FFCCBC",
        color: "#000000"
    };

    const previewButtonNote = () => {
        if (noteType === "A") {
            return (
                <div className='col-md-2 question_note_card'>
                    <span className='btn_question_note_card' style={getButtonStyle}>A</span>
                </div>
            );
        } else if (noteType === "PA") {
            return (
                <div className='col-md-2 question_note_card'>
                    <span className='btn_question_note_card' style={getButtonStyle}>PA</span>
                </div>
            );
        } else if (noteType === "I") {
            return (
                <div className='col-md-2 question_note_card'>
                    <span className='btn_question_note_card' style={getButtonStyle}>I</span>
                </div>
            );
        }
    };

    return (
        <Card>
            <Card.Body>
                <Card.Text>
                    <div className='row question_col_card_container'>
                        <div className='col-md-10 question_col_card_content question_col_card_start'>
                            <small className='question_col_card_paragraph'>{removeHtmlTags(paragraph)}</small>
                        </div>

                        {
                            previewButtonNote()
                        }
                    </div>
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

const ActorNotes = ({ sendDataNotes }) => {
    return (
        <div className='col-md-12'>
            {
                sendDataNotes.map((note, index) => (
                    <SingleNote
                        key={`${note.paragraph}-${index}`}
                        index={index}
                        noteType={note.noteType}
                        paragraph={note.paragraph}
                    />
                ))
            }
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ActorNotes);